(() => {
  const failure='Der Widerruf konnte nicht vollständig übermittelt werden. Bitte versuche es erneut oder kontaktiere uns per E-Mail.';
  for(const root of document.querySelectorAll('[data-withdrawal]')) {
    if(root.dataset.initialized)continue;
    root.dataset.initialized='true';
    const form=root.querySelector('form'),fieldset=form.querySelector('fieldset'),status=root.querySelector('[data-withdrawal-status]');
    let requestId,busy=false,attemptedPayload=null;
    const storageKey='withdrawal-pending-v1';
    const saveAttempt=()=>{try{sessionStorage.setItem(storageKey,JSON.stringify({requestId,attemptedPayload}));}catch{/* In-memory idempotency still applies. */}};
    const endpoint=new URL(root.dataset.endpoint,location.origin);
    if(endpoint.origin!==location.origin||root.dataset.connected!=='true')continue;
    const jsonRequest=async(options={})=>{
      const response=await fetch(endpoint,{...options,credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},signal:AbortSignal.timeout(90000)});
      const body=await response.json();
      return {response,body};
    };
    const initialize=async()=>{
      try {
        const {response,body}=await jsonRequest();
        if(!response.ok||!body.enabled||!body.requestId)throw Error('unavailable');
        requestId=body.requestId;
        try {const saved=JSON.parse(sessionStorage.getItem(storageKey));if(saved?.requestId){requestId=saved.requestId;attemptedPayload=saved.attemptedPayload||null;}}catch{/* Start a new local form session. */}
        saveAttempt();fieldset.disabled=false;status.textContent='';status.hidden=true;
      } catch {status.textContent='Das Formular ist derzeit nicht verfügbar. Bitte kontaktiere uns über die E-Mail-Adresse auf der Seite Widerrufsrecht.';}
    };
    for(const error of form.querySelectorAll('[data-error]')) {
      const control=form.elements.namedItem(error.dataset.error);
      error.id=control.id?control.id+'-error':'withdrawal-confirm-error';
      control.setAttribute('aria-describedby',error.id);
    }
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      if(busy||!requestId||!form.reportValidity())return;
      const data=Object.fromEntries(new FormData(form));data.confirmed=form.elements.namedItem('confirmed').checked;
      busy=true;
      const bytes=await crypto.subtle.digest('SHA-256',new TextEncoder().encode(JSON.stringify(data)));
      const payload=Array.from(new Uint8Array(bytes),v=>v.toString(16).padStart(2,'0')).join('');
      // Keep the same id after an uncertain result. Do not let changed input create duplicate declarations.
      if(attemptedPayload&&attemptedPayload!==payload){busy=false;status.hidden=false;status.textContent='Diese Erklärung wurde bereits übermittelt oder wird noch verarbeitet. Bitte wiederhole den Versuch mit unveränderten Angaben oder kontaktiere uns per E-Mail.';status.focus();return;}
      busy=true;fieldset.disabled=true;status.hidden=false;status.textContent='Dein Widerruf wird übermittelt …';
      for(const error of form.querySelectorAll('[data-error]')){error.textContent='';form.elements.namedItem(error.dataset.error).removeAttribute('aria-invalid');}
      attemptedPayload=payload;saveAttempt();
      try {
        const {response,body}=await jsonRequest({method:'POST',body:JSON.stringify({...data,requestId})});
        if(!response.ok||body.ok!==true) {
          if(response.status===422&&body.fields) {
            attemptedPayload=null;saveAttempt();
            for(const [key,text] of Object.entries(body.fields)) {
              const error=[...form.querySelectorAll('[data-error]')].find(e=>e.dataset.error===key);
              if(error){error.textContent=text;form.elements.namedItem(key).setAttribute('aria-invalid','true');}
            }
          }
          throw Error('unconfirmed');
        }
        form.hidden=true;
        status.textContent=`Dein Widerruf wurde übermittelt.\nEine Bestätigung wurde an ${body.email} gesendet.\nWiderrufs-ID: ${body.id}`;
      } catch {status.textContent=failure;}
      finally {busy=false;fieldset.disabled=false;status.focus();}
    });
    initialize();
  }
})();
